import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './features/home/pages/home';
import { QueryClient, QueryClientProvider } from 'react-query';
import { PromoRoutes } from './features/promo';
import { UserRoutes } from './features/user';
import { RevenueRoutes } from './features/revenue';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="promo/*" element={<PromoRoutes />} />
          <Route path="revenue/*" element={<RevenueRoutes />} />
          <Route path="user/*" element={<UserRoutes />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
